import axios from "utils/axios";

// Perusahaan internal (khusus website internal Kledo). Dipakai saat update status
// meeting → Selesai untuk forward laporan ke AdminHebat (pilih app + perusahaan).

export const searchInternalCompanies = ({ app_id, q }) => {
  return axios.get("/WA/internal/companies/search", {
    params: { app_id, q },
  });
};

export const getInternalCompanyRecommendations = ({ app_id, contact_id }) => {
  return axios.get("/WA/internal/companies/recommendations", {
    params: { app_id, contact_id },
  });
};
